import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, signal } from "@angular/core";
import { DashLangService } from "../../../../modules/home/dash/service/dash.lang.service";
import { DashSectionToolboxBridge } from "../../../../modules/home/dash/service/dash.section.toolbox.bridge";
import { S25IconComponent } from "../../../../modules/s25-icon/s25.icon.component";
import { s25Resource } from "../../../../util/s25.resource";

@Component({
    selector: "s25-ng-dash-section-customize",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, S25IconComponent],
    host: {
        class: "section-customize",
        "attr.data-dash-section-customize": "",
    },
    template: `
        @if (customizeRow(); as row) {
            <div class="dash-tb-body">
                <div class="tb-row c-dashboardTools">
                    <div [attr.id]="row.style" class="tb-col lh-none" style="display: inline-block">
                        <div
                            class="section-customize-object inline-block text-main"
                            role="button"
                            aria-label="Customize Dashboard"
                            tabindex="0"
                            (click)="onCustomizeActivate()"
                            (keydown.enter)="onCustomizeActivate()"
                            (mouseenter)="hovering.set(true)"
                            (mouseleave)="hovering.set(false)"
                        >
                            <div class="inline-block">
                                <div class="dash-tb-body-inline lh-initial">
                                    <div class="tb-row">
                                        <span class="tb-col dh-col-a">
                                            <s25-ng-icon [type]="'cog'" [ariaLabel]="false" />
                                        </span>
                                        <span class="tb-col item-text" [class.hover]="hovering()" aria-hidden="true">{{
                                            row.text
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    `,
})
export class HomeDashSectionCustomizeComponent {
    readonly dashLangResource = s25Resource(() => DashLangService.getLang());
    readonly hovering = signal(false);

    readonly customizeRow = computed(() => this.dashLangResource.value()?.section.customize.a);

    onCustomizeActivate(): void {
        window.scrollTo({ top: 0, behavior: "smooth" });
        DashSectionToolboxBridge.emitOpen();
        window.setTimeout(() => {
            document.getElementById("dashSectionToolbox")?.focus();
        }, 350);
    }
}
